/* eslint-disable @typescript-eslint/no-explicit-any */

import { ApplicationQuestion } from '@/types/ApplicationQuestion';
import { ApplicationQuestionAnswer } from '@/types/ApplicationQuestionAnswer';
import { CandidateWithJobContextBasicInfo } from '@/types/Candidate';
import { Job } from '@/types/Job';
import { isAxiosError } from 'axios';
import { api, ApiResponse } from '@/api/api';
import { APPLICATION_QUESTIONS_URLS } from '@/api/url';

export interface GetApplicationQuestionsParams {
  token: string;
}

export interface GetApplicationQuestionsResponse {
  agency: Agency;
  job_info: Job;
  candidate_info: CandidateWithJobContextBasicInfo;
  application_questions: ApplicationQuestion[];
  application_answers: ApplicationQuestionAnswer[];
}

export const apiGetApplicationQuestions = async ({
  token
}: GetApplicationQuestionsParams): Promise<ApiResponse<GetApplicationQuestionsResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetApplicationQuestionsResponse>>(
      APPLICATION_QUESTIONS_URLS.GET,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface SubmitApplicationQuestionsPayload {
  application_answers: ApplicationQuestionAnswer[];
}

export const apiSubmitApplicationQuestions = async ({
  token,
  payload
}: {
  token: string;
  payload: SubmitApplicationQuestionsPayload;
}): Promise<ApiResponse<void>> => {
  try {
    const response = await api.post<ApiResponse<void>>(APPLICATION_QUESTIONS_URLS.SUBMIT, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
